import { useState } from 'react';
import { inputCls } from '../ui/classes';
import { ProseAssist } from './ProseAssist';

interface Props {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  autoFocus?: boolean;
  rows?: number;
  placeholder?: string;
}

/** Pole na wklejoną listę z przyciskami „Wyczyść”, „Wklej ze schowka” i rozpisaniem wiadomości przez AI. */
export function DraftInput({ id, label, value, onChange, autoFocus = false, rows = 6, placeholder = 'mleko x2\nchleb\njajka 10 szt\nmasło 200 g' }: Props) {
  const [clipError, setClipError] = useState<string | null>(null);
  const canPaste = typeof navigator.clipboard?.readText === 'function';

  const paste = async () => {
    setClipError(null);
    try {
      const clip = await navigator.clipboard.readText();
      if (clip.trim()) onChange(value.trim() ? `${value.trimEnd()}\n${clip}` : clip);
      else setClipError('Schowek jest pusty.');
    } catch {
      setClipError('Brak dostępu do schowka. Przytrzymaj pole i wybierz „Wklej”.');
    }
  };

  return (
    <div className="flex flex-col gap-1">
      <div className="flex min-h-11 items-center gap-2 px-1">
        <label htmlFor={id} className="flex-1 text-sm font-medium text-stone-600 dark:text-stone-400">
          {label}
        </label>
        {value && (
          <button type="button" onClick={() => onChange('')} className="min-h-11 px-2 text-sm text-stone-500">
            Wyczyść
          </button>
        )}
        {canPaste && (
          <button
            type="button"
            onClick={paste}
            className="min-h-11 rounded-lg px-3 text-sm font-medium text-brand-700 active:bg-brand-50 dark:text-brand-500 dark:active:bg-stone-800"
          >
            Wklej ze schowka
          </button>
        )}
      </div>
      <textarea
        id={id}
        autoFocus={autoFocus}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        autoCapitalize="none"
        spellCheck={false}
        className={`${inputCls} resize-y leading-relaxed`}
      />
      <ProseAssist value={value} onChange={onChange} />
      {clipError && <p className="px-1 text-sm text-red-600 dark:text-red-400">{clipError}</p>}
    </div>
  );
}
